import { ZIndexOptions } from "@mui/material/styles/zIndex";

export const zIndex: ZIndexOptions = {
  hubspot: 2147483647,
  consent: 10000000,
};
